"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Hogan = _interopRequireWildcard(require("hogan.js"));

var _diff2htmlTemplates = require("./diff2html-templates");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var HoganJsUtils = function () {
  function HoganJsUtils(_a) {
    var _b = _a.compiledTemplates,
        compiledTemplates = _b === void 0 ? {} : _b,
        _c = _a.rawTemplates,
        rawTemplates = _c === void 0 ? {} : _c;
    var compiledRawTemplates = Object.entries(rawTemplates).reduce(function (previousTemplates, _a) {
      var _b;

      var name = _a[0],
          templateString = _a[1];
      var compiledTemplate = Hogan.compile(templateString, {
        asString: false
      });
      return __assign(__assign({}, previousTemplates), (_b = {}, _b[name] = compiledTemplate, _b));
    }, {});
    this.preCompiledTemplates = __assign(__assign(__assign({}, _diff2htmlTemplates.defaultTemplates), compiledTemplates), compiledRawTemplates);
  }

  HoganJsUtils.compile = function (templateString) {
    return Hogan.compile(templateString, {
      asString: false
    });
  };

  HoganJsUtils.prototype.render = function (namespace, view, params, partials, indent) {
    var templateKey = this.templateKey(namespace, view);

    try {
      var template = this.preCompiledTemplates[templateKey];
      return template.render(params, partials, indent);
    } catch (e) {
      throw new Error("Could not find template to render '" + templateKey + "'");
    }
  };

  HoganJsUtils.prototype.template = function (namespace, view) {
    return this.preCompiledTemplates[this.templateKey(namespace, view)];
  };

  HoganJsUtils.prototype.templateKey = function (namespace, view) {
    return namespace + "-" + view;
  };

  return HoganJsUtils;
}();

var _default = HoganJsUtils;
exports.default = _default;